let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("emd3r"), load("aZinD"), load("6qah4"), load("kUbT8")]).then(() => parcelRequire('4KbgO'));